export default __webpack_public_path__ + "static/media/BetterMeImg.96ca39e9.png";